export type ModelTransformer<From, To> = {
    transform(value: From): To
    reverseTransform(value: To): From
}

export type BooleanToStringTransformer = ModelTransformer<boolean, string>

export const booleanToStringTransformer: BooleanToStringTransformer = {
    transform: booleanToString,
    reverseTransform: stringToBoolean,
}

export type OptionalBooleanToStringTransformer = ModelTransformer<
    boolean | undefined,
    string | undefined
>

export const optionalBooleanToStringTransformer: OptionalBooleanToStringTransformer =
    {
        transform(value: boolean | undefined): string | undefined {
            if (undefined === value) {
                return undefined
            }

            return booleanToString(value)
        },
        reverseTransform(value: string | undefined): boolean | undefined {
            if (undefined === value) {
                return undefined
            }

            return stringToBoolean(value)
        },
    }

export type BooleanToOptionalStringTransformer = ModelTransformer<
    boolean,
    string | undefined
>

export const booleanToOptionalStringTransformer: BooleanToOptionalStringTransformer =
    {
        transform(value: boolean): string | undefined {
            if (!value) {
                return undefined
            }

            return booleanToString(value)
        },
        reverseTransform(value: string | undefined): boolean {
            if (undefined === value) {
                return false
            }

            return stringToBoolean(value)
        },
    }

function booleanToString(value: boolean): string {
    return String(Number(!!Number(value)))
}

function stringToBoolean(value: string): boolean {
    return !!Number(value)
}

// export type BooleanToOptionalStringTransformer = ModelTransformer<
//     boolean,
//     string | undefined
// >
//
// export const booleanToOptionalStringTransformer: BooleanToOptionalStringTransformer =
//     {
//         transform(value: boolean): string | undefined {
//             if (!value) {
//                 return undefined
//             }
//
//             return booleanToString(value)
//         },
//         reverseTransform(value: string | undefined): boolean {
//             if (undefined === value) {
//                 return false
//             }
//
//             return stringToBoolean(value)
//         },
//     }
